const i18n = {
  fr: {
    contribute: 'Vous contribuez à',
    fund: 'Vous financez',
  },
  en: {
    contribute: 'You contribute to',
    fund: 'You fund',
  },
  'pt-br': {
    contribute: 'Você contribui para',
    fund: 'Você financia',
  },
  es: {
    contribute: 'Contribuyes a',
    fund: 'Financias',
  },
  de: {
    contribute: 'Sie tragen zu',
    fund: 'Sie finanzieren',
  },
}

export default i18n
